import { render, staticRenderFns } from "./EditExerciseConversation.vue?vue&type=template&id=fdaa36e2&"
import script from "./EditExerciseConversation.vue?vue&type=script&lang=ts&"
export * from "./EditExerciseConversation.vue?vue&type=script&lang=ts&"
import style0 from "./EditExerciseConversation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports